var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLimboPendingAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25C26.48 25 22 29.48 22 35C22 40.52 26.48 45 32 45C37.52 45 42 40.52 42 35C42 29.48 37.52 25 32 25ZM35.3 39.7L31 35.4V29H33V34.58L36.7 38.28L35.3 39.7ZM34 7H27.64C26.8 4.68 24.6 3 22 3C19.4 3 17.2 4.68 16.36 7H10C7.8 7 6 8.8 6 11V41C6 43.2 7.8 45 10 45H22.22C21.04 43.86 20.08 42.5 19.38 41H10V11H14V17H30V11H34V21.16C35.42 21.36 36.76 21.78 38 22.36V11C38 8.8 36.2 7 34 7ZM22 11C20.9 11 20 10.1 20 9C20 7.9 20.9 7 22 7C23.1 7 24 7.9 24 9C24 10.1 23.1 11 22 11Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimboPendingAction);
export default __webpack_public_path__ + "static/media/limbo_pending_action.d6c1a822.svg";
export { ForwardRef as ReactComponent };